export function formatDate(date: Date | number) {
  if (typeof date == 'number') {
    date = new Date(date * 1000)
  }
  return [('0' + date.getDate()).slice(-2), ('0' + (date.getMonth() + 1)).slice(-2), date.getFullYear()].join('.')
}
